import React from 'react';
import { useGuide } from './useGuide';
import { TooltipPosition } from './types';
import {
  $TooltipContainer,
  $TooltipContent,
  $TooltipHeader,
  $TooltipTitle,
  $TooltipStep,
  $TooltipDescription,
  $TooltipActions,
  $SkipButton,
  $NextButton,
  $TooltipArrow,
} from './GuideTooltip.styled';

interface GuideTooltipProps {
  position?: TooltipPosition;
  className?: string;
}

export const GuideTooltip: React.FC<GuideTooltipProps> = ({
  position = 'top',
  className,
}) => {
  const { state, getCurrentStep, nextStep, skipGuide, config } = useGuide();

  if (!state.isActive || !config) return null;

  const currentStep = getCurrentStep();
  if (!currentStep) return null;

  const isLastStep = state.currentStepIndex === config.steps.length - 1;
  const stepNumber = state.currentStepIndex + 1;
  const totalSteps = config.steps.length;

  const getButtonText = () => {
    if (isLastStep) return 'Done';
    return 'Next';
  };

  return (
    <$TooltipContainer position={position} className={className}>
      <$TooltipArrow position={position} />
      <$TooltipContent>
        <$TooltipHeader>
          <$TooltipStep>
            Step {stepNumber}/{totalSteps}
          </$TooltipStep>
          <$TooltipTitle>{currentStep.title}</$TooltipTitle>
        </$TooltipHeader>
        <$TooltipDescription>{currentStep.description}</$TooltipDescription>
        <$TooltipActions>
          {!isLastStep && <$SkipButton onClick={skipGuide}>Skip</$SkipButton>}
          <$NextButton onClick={nextStep}>{getButtonText()}</$NextButton>
        </$TooltipActions>
      </$TooltipContent>
    </$TooltipContainer>
  );
};
